import axios from "axios";

const API_BASE = process.env.REACT_APP_API_URL;

const templateAPI = axios.create({
  baseURL: `${API_BASE}/api/templates`,
  headers: {
    "Content-Type": "application/json",
  },
});

// ✅ UPDATED: Create template (handles both JSON and FormData)
export const createTemplate = async (authToken, templateData) => {
  // ✅ Detect if templateData is FormData or regular object
  const isFormData = templateData instanceof FormData;

  return templateAPI.post("/", templateData, {
    headers: {
      Authorization: `Bearer ${authToken}`,
      "Content-Type": isFormData ? "multipart/form-data" : "application/json",
    },
  });
};

// Submit template to Meta for approval
export const submitTemplateForApproval = async (
  authToken,
  templateId,
  phoneId = null
) => {
  return templateAPI.post(
    `/${templateId}/submit`,
    { phoneId },
    {
      headers: {
        Authorization: `Bearer ${authToken}`,
        "Content-Type": "application/json",
      },
    }
  );
};

// ✅ NEW: Refresh template status from Meta
export const refreshTemplateStatus = async (authToken, templateId) => {
  return templateAPI.post(
    `/${templateId}/refresh-status`,
    {},
    {
      headers: {
        Authorization: `Bearer ${authToken}`,
        "Content-Type": "application/json",
      },
    }
  );
};

// Get all templates for user
// New format: getTemplates(authToken, { wabaId, phoneId, limit, offset, status, category, language, searchTerm })
export const getTemplates = async (authToken, filters = {}) => {
  const requestBody = {
    wabaId: filters.wabaId || null,
    phoneId: filters.phoneId || null,
    limit: filters.limit || 50,
    offset: filters.offset || 0,
    ...(filters.status && { status: filters.status }),
    ...(filters.category && { category: filters.category }),
    ...(filters.language && { language: filters.language }),
    ...(filters.searchTerm && { searchTerm: filters.searchTerm }),
  };
  return templateAPI.post(
    `/get-templates`,
    requestBody,
    {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    }
  );
};

// Get single template
export const getTemplateById = async (authToken, templateId) => {
  return templateAPI.get(`/${templateId}`, {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  });
};

// ✅ UPDATED: Update template (handles both JSON and FormData)
export const updateTemplate = async (authToken, templateId, templateData) => {
  const isFormData = templateData instanceof FormData;

  return templateAPI.put(`/${templateId}`, templateData, {
    headers: {
      Authorization: `Bearer ${authToken}`,
      "Content-Type": isFormData ? "multipart/form-data" : "application/json",
    },
  });
};

// Update template status
export const updateTemplateStatus = async (authToken, templateId, status) => {
  return templateAPI.put(
    `/${templateId}/status`,
    { status },
    {
      headers: {
        Authorization: `Bearer ${authToken}`,
        "Content-Type": "application/json",
      },
    }
  );
};

// Delete template
export const deleteTemplate = async (authToken, templateId) => {
  return templateAPI.delete(`/${templateId}`, {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  });
};

// ✅ NEW: Generate template from AI prompt
export const generateTemplateFromAI = async (authToken, data) => {
  return templateAPI.post("/generate-ai", data, {
    headers: {
      Authorization: `Bearer ${authToken}`,
      "Content-Type": "application/json",
    },
  });
};

/* ==========================================================
   🔄 TEMPLATE SYNC APIs
========================================================== */

// Sync all templates from Meta for a specific WABA
// Fetches all templates with pagination and stores/updates in the database
export const syncTemplatesFromMeta = async (authToken, wabaId, phoneId) => {
  return templateAPI.post(
    "/sync",
    { wabaId, phoneId },
    {
      headers: {
        Authorization: `Bearer ${authToken}`,
        "Content-Type": "application/json",
      },
      timeout: 120000, // 2 minute timeout for sync operations
    }
  );
};

// Sync templates for all WABAs of the authenticated user
export const syncAllTemplates = async (authToken) => {
  return templateAPI.post(
    "/sync-all",
    {},
    {
      headers: {
        Authorization: `Bearer ${authToken}`,
        "Content-Type": "application/json",
      },
      timeout: 300000, // 5 minute timeout for full sync
    }
  );
};

// Get sync status for a WABA
export const getSyncStatus = async (authToken, wabaId) => {
  return templateAPI.get(`/sync-status/${wabaId}`, {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  });
};

export default templateAPI;
